import { HistoryStoreImpl } from './store';

export type { HistoryItem } from './types/index';

export const useHistoryStore = HistoryStoreImpl.getInstace;
